import { Col, Card, CardBody, CardTitle } from "reactstrap";

const PopularHashtags = ({ reportData, ...props }) => {
  return (
    <Col sm="6" className="d-flex align-items-stretch mb-4">
      <Card className="card-content-custom">
        <CardBody>
          <CardTitle>
            <span className="tooltip-button-wrap">
              <span className="text-tooltip">Popular Hashtags</span>
            </span>
          </CardTitle>
          <div className="popular-tags ch-5">
            <ul>
              {reportData?.user_profile?.top_hashtags ? (
                reportData?.user_profile?.top_hashtags?.map((tag, index) => {
                  if (index < 10 && tag.tag.length < 15) {
                    return <li key={index}>#{tag.tag}</li>;
                  }
                  return null;
                })
              ) : (
                <span className="text-center text-grey ">
                  <p className="pt-50">No hashtags found</p>
                </span>
              )}
            </ul>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PopularHashtags;
